import React, { useState } from "react";

const faqLinks = {
  tracks: "https://ICAN.helixconferences.com/ICAN-tracks/",
  abstractSubmission: "https://ICAN.helixconferences.com/abstractsubmission/",
  schedule: "https://ICAN.helixconferences.com/ICAN-event-schedule",
  email: "mailto:hello@helixconferences.com",
};

export const faqData = [
  {
    question: "What is ICAN 2025?",
    answer:
      "<strong>ICAN 2025</strong>, the <strong>International Conference on Autism and Neuropsychiatry</strong>, is a premier <strong>Global Autism Summit</strong> and one of the leading <strong>2025 Autism Conferences</strong>. It gathers global experts to advance <strong>Neuroscience Research</strong> and compassionate care for neurodevelopmental conditions.",
  },
  {
    question: "How does ICAN 2025 stand out among other Global Neuroscience Events?",
    answer:
      "While many <strong>Upcoming Neurology Conferences 2025</strong> are broad, <strong>ICAN 2025</strong> offers a specialized focus on bridging autism research with clinical neuropsychiatry. It emphasizes <strong>Patient-Centric Solutions</strong>, <strong>Neurodivergent Support</strong>, and brings together a unique mix of scientists, clinicians, educators, and <strong>Neurodiversity Advocates</strong>.",
  },
  {
    question: "When and where will the conference take place?",
    answer:
      "The official date and venue for <strong>ICAN 2025</strong> are yet to be announced. Please check our website regularly for the latest updates on scheduling.",
  },
  {
    question: "Who is the target audience for this event?",
    answer:
      "We welcome neurologists, psychiatrists, <strong>Autism Researchers</strong>, therapists, pediatricians, educators, caregivers, <strong>Public Health Leaders</strong>, and policymakers dedicated to advancing <strong>Brain Health</strong> and autism care.",
  },
    {
    question: "How does ICAN focus on patient-centric solutions?",
    answer:
      "At its core, <strong>ICAN</strong> aims to translate complex <strong>Neuroscience Research</strong> into practical, compassionate care. The program is designed to include discussions on integrative support, caregiver perspectives, and real-world applications of emerging therapies to directly benefit individuals and families.",
  },
  {
    question: "What are the key conference tracks and themes?",
    answer: (
      <>
        The conference covers a wide spectrum of topics essential to modern neuropsychiatry. Key tracks include <strong>Autism Research</strong>, <strong>ADHD</strong>, <strong>Neuroscience</strong>, Trauma, <strong>Behavioral Science</strong>, <strong>AI and Digital Psychiatry</strong>, and <strong>Forensic Neuropsychiatry</strong>. View the complete list of tracks{" "}
        <a href={faqLinks.tracks} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
          here
        </a>
        .
      </>
    ),
  },
  {
    question: "Will topics like Alzheimer's, Dementia, and Rehabilitation be covered?",
    answer:
      "Yes. The conference scope extends to broader neuropsychiatric and neurodegenerative conditions. We feature dedicated tracks on <strong>Alzheimer’s Research</strong>, <strong>Dementia Diagnosis & Care</strong>, and <strong>Neurological Rehabilitation</strong> to foster a comprehensive dialogue on brain health.",
  },
  {
    question: "Does the conference discuss medication and drug therapies?",
    answer:
      "Absolutely. Our program includes specialized tracks on <strong>Pharmacological Interventions</strong> and <strong>Psychopharmacology</strong>, which delve into modern drug therapies, precision medicine, and the effects of medication on mood, behavior, and cognition.",
  },
  {
    question: "How is ICAN 2025 addressing Public Health aspects of mental wellness?",
    answer:
      "<strong>ICAN 2025</strong> features a dedicated <strong>Public Health</strong> track that focuses on mental health at a population level. Discussions will cover policy, prevention strategies, community resilience, access to care, and reducing stigma for diverse and underserved populations globally.",
  },
  {
    question: "What are the requirements for an abstract submission?",
    answer: (
      <>
        We invite submissions of original, unpublished research relevant to the conference tracks. Abstracts must follow the guidelines specified on our submission page regarding format, length, and content. For full details, please visit the{" "}
        <a href={faqLinks.abstractSubmission} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
          abstract submission page
        </a>
        .
      </>
    ),
  },
  {
    question: "What networking opportunities will be available?",
    answer:
      "<strong>ICAN 2025</strong> is designed to be a pivotal gathering of minds. Attendees will have ample opportunities to connect with industry leaders, researchers, and peers through dedicated networking forums, interactive workshops, and Q&A sessions.",
  },
  // {
  //   question: "Will I receive a certificate for attending?",
  //   answer:
  //     "Yes, all fully registered participants who attend the conference will receive an official Certificate of Attendance for <strong>ICAN 2025</strong>, which can be used for professional development records.",
  // },
  {
    question: "How can I see the detailed event schedule?",
    answer: (
      <>
        The full event schedule, including keynote lectures, session times, and speaker details, will be published on our website. You can access it{" "}
        <a href={faqLinks.schedule} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
          here
        </a>
        {" "}once it is finalized.
      </>
    ),
  },
  {
    question: "Are there opportunities for sponsorship or exhibition?",
    answer: (
      <>
        Yes, we offer various sponsorship and exhibition packages. For more information on how to showcase your work and support this <strong>Global Autism Summit</strong>, please contact our team at{" "}
        <a href={faqLinks.email} className="text-blue-600 underline">
          hello@helixconferences.com
        </a>
        .
      </>
    ),
  },
  {
    question: "Who should I contact for more information?",
    answer: (
      <>
        For any further inquiries regarding registration, program details, or participation in <strong>ICAN 2025</strong>, please don't hesitate to reach out to us at{" "}
        <a href={faqLinks.email} className="text-blue-600 underline">
          hello@helixconferences.com
        </a>
        .
      </>
    ),
  },
];


// The Faq component remains exactly the same as the last version,
// as the changes are only in the faqData content.
const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h2 className="text-3xl font-bold mb-6 text-center">Frequently Asked Questions</h2>
      {faqData.map((item, index) => (
        <div key={index} className="border-b border-gray-300 mb-4">
          <button
            className="w-full text-left py-4 px-2 font-medium text-lg flex justify-between items-center"
            onClick={() => toggle(index)}
          >
            {item.question}
            <span className="text-xl">{openIndex === index ? "−" : "+"}</span>
          </button>
          {openIndex === index && (
            <div className="px-4 pb-4 text-gray-700">
              {typeof item.answer === 'string' ? (
                // Use dangerouslySetInnerHTML for HTML strings
                <span dangerouslySetInnerHTML={{ __html: item.answer }} />
              ) : (
                // Render JSX directly (for cases where answer is a JSX fragment)
                item.answer
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Faq;